import React, { useContext, useEffect, useState } from 'react'
import ArtworldContext from './../../context/ArtworldContext'
import Select from 'react-select'
import { findSearchOption } from './../../helpers'
import { includes, isArray } from 'lodash'

const inputKey = 'places__categories__in'

let optionsSelected = null

const PlacesCategories = () => {

    const context = useContext(ArtworldContext)

    const [options, setOptions] = useState('')

    const onChange = selectedOptions => {

        const selected = selectedOptions ? selectedOptions.map(selectedOption => {
            return selectedOption.value
        }) : context.advancedSearch[inputKey]

        context.updateAdvancedSearch('places', 'categories__in', selected);

        optionsSelected = selected
    };

    /**
     * Create options list when filters return from API
     */
    useEffect(() => {

        if (context.advancedSearchFilters && context.advancedSearchFilters.places && context.advancedSearchFilters.places.categories) {

            const options = context.advancedSearchFilters.places.categories.map(category => {
                return {
                    value: category.id,
                    label: category.title
                }
            })

            setOptions(options)
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [context.advancedSearchFilters])

    if (window.location.search) {

        const searchOption = findSearchOption(inputKey)

        optionsSelected = []

        if (isArray(searchOption)) {
            searchOption.map(option => {
                optionsSelected.push(parseInt(option))
                return option
            })
        } else {
            optionsSelected.push(parseInt(searchOption))
        }

    }

    return (
        <div className="columns is-multiline is-variable">

            <div className="column is-full">

                Browse all entries by category:

                <Select
                    value={options && optionsSelected ? options.filter(option => includes(optionsSelected, parseInt(option.value))) : ''}
                    onChange={onChange}
                    options={options}
                    isMulti
                />

            </div>

        </div>
    );
};

export default PlacesCategories;
